import { render, staticRenderFns } from "./notice-list.vue?vue&type=template&id=0f04303d&scoped=true"
import script from "./notice-list.vue?vue&type=script&lang=js"
export * from "./notice-list.vue?vue&type=script&lang=js"
import style0 from "./notice-list.vue?vue&type=style&index=0&id=0f04303d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04303d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f04303d')) {
      api.createRecord('0f04303d', component.options)
    } else {
      api.reload('0f04303d', component.options)
    }
    module.hot.accept("./notice-list.vue?vue&type=template&id=0f04303d&scoped=true", function () {
      api.rerender('0f04303d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/notice-management/notice-list.vue"
export default component.exports